import { render, staticRenderFns } from "./CalendarDashboardRecent.vue?vue&type=template&id=5907ac2f"
import script from "./CalendarDashboardRecent.vue?vue&type=script&lang=js"
export * from "./CalendarDashboardRecent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports